import { render, staticRenderFns } from "./TotalEarnedPoints.vue?vue&type=template&id=dd3ed5a2&scoped=true&"
import script from "./TotalEarnedPoints.vue?vue&type=script&lang=js&"
export * from "./TotalEarnedPoints.vue?vue&type=script&lang=js&"
import style0 from "./TotalEarnedPoints.vue?vue&type=style&index=0&id=dd3ed5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3ed5a2",
  null
  
)

export default component.exports